<template>
  <v-responsive class="overflow-y-auto" max-height="calc(80vh - 320px)">
    <v-data-table
      v-model="selectedStudent"
      :options.sync="teacherTableOptions"
      :server-items-length="totalItems"
      :headers="headers"
      :items-per-page="5"
      :items="teachers"
      :footer-props="footerTable"
      loading-text="Đang Tải"
      show-select
      :loading="loading"
      ref="clear"
      disable-sort
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :items-per-page="5"
          :page-text="pageText"
          :pagination="pagination"
          :options="options"
          :items-per-page-options="totalItems > 100 ? [5, 10, 15] : [5, 10, 15, -1]"
          @update:options="updateOptions"
          items-per-page-text="Giáo viên mỗi trang"
          items-per-page-all-text="Tất cả"
        />
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <CardTeacherName :teacher="item" link isCodeShown />
      </template>
      <template v-slot:[`item.dob`]="{ item }">
        <span>{{ item.dob | ddmmyyyy }}</span>
      </template>
    </v-data-table>
  </v-responsive>
</template>

<script>
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import { mapState, mapActions, mapMutations } from 'vuex'

const originHeaders = [
  {
    text: 'Tên giáo viên',
    value: 'name',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'center',
  },
]

export default {
  data() {
    return {
      headers: this.propHeaders && this.propHeaders.length ? this.propHeaders : originHeaders,
      teacherTableOptions: {},
      selectedStudent: []
    }
  },
  components: {
    CardTeacherName
  },
  computed: {
    ...mapState('teachers', ['totalItems', 'teachers', 'pageText', 'loading', 'teacherSearchParams']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số giáo viên mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('teachers', ['requestPageSettings', 'searchTeachers']),
    ...mapMutations('salaryGroupTeacher', ['setSelectedStudent']),
    async refresh(query) {
      await this.searchTeachers({ ...query })
    },
    clearSelected() {
      this.selectedStudent = []
    }
  },
  async created() {
    await this.refresh({ ...this.filter })
  },
  watch: {
    teacherTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    },
    selectedStudent: {
      handler() {
        this.setSelectedStudent(this.selectedStudent)
      }
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
